import { defineExperiment, loose } from "../defineExperiment";

export const WEB_CALENDAR_QUOTA = defineExperiment("WEB_CALENDAR_QUOTA", {
  google: loose.number(),
  microsoft: loose.number(),
  apple: loose.number(),
  global_idle_refresh_rate_minutes: loose.number(),
});
